import { createAsyncThunk } from "@reduxjs/toolkit";

import { mapQuotations, mapMaterialDataUnits } from "../Types/Quotation/QuotationType";
import { mapQuotationTemplates } from "../Types/Quotation/QuotationTemplate";
import { mapQuotationNotes } from "../Types/Quotation/QuotationNoteType";
import { getAllQuotations, getAllQuotationTemplates, getQuotationNoteList, getMaterialDataUnit } from "../../Api/Quotation/QuotationApiService";

// Get all quotation data
export const fetchQuotationData = createAsyncThunk('fetchQuotationData', async (_, { rejectWithValue }) => {
    try {
        // api
        const response = await getAllQuotations();
        if (response.status) {
            return mapQuotations(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch quotation data');
    }
});

// Get all quotation templates
export const fetchQuotationTemplates = createAsyncThunk('fetchQuotationTemplates', async (_, { rejectWithValue }) => {
    try {
        // api
        const response = await getAllQuotationTemplates();
        if (response.status) {
            return mapQuotationTemplates(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch quotation templates');
    }
});

// Get all quotation note list
export const fetchQuotationNoteList = createAsyncThunk('fetchQuotationNoteList', async (_, { rejectWithValue }) => {
    try {
        // api
        const response = await getQuotationNoteList();
        if (response.status) {
            return mapQuotationNotes(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch quotation templates');
    }
});

// Get material data unit
export const fetchMaterialDataUnit = createAsyncThunk('fetchMaterialDataUnit', async (_, { rejectWithValue }) => {
    try {
        // api
        const response = await getMaterialDataUnit();
        if (response.status) {
            return mapMaterialDataUnits(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch quotation templates');
    }
});